export default __webpack_public_path__ + "static/media/CapresseSalad.3644ac11.jpg";